import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import CognitoFormScreen from './containers/CognitoFormScreenContainer';

const register = () => {
  Logger.log('debug', `cognitoForms.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'cognitoForms', 'routes'])) {
    Events.dispatch('ADD_DEFAULT_ROUTES', {
      CognitoFormScreen: [
        'PrivateRoute',
        '/cognito-forms',
        true,
        CognitoFormScreen,
        getI18n().t('cognito_forms_admin_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `cognitoForms.register() loaded.`);
